module.exports = __webpack_public_path__ + "assets/webgl/art_063_L0.jpg.astc.acb2f906.ktx";